/**
 * ModalForm component that can show on top of Nexus with some content.
 *
 *
 * <i>Copyright (c) 2020 Energi Cryptocurrency - https://energi.world</i><br>
 * Proprietary License
 *
 *
 * @module components/seo.jsx
 * @class ModalForm
 * @since 0.10.16
*/

import React from 'react';
import {Button} from '@rmwc/button';
import modalFormState from '../globals/modal-form';
import translations from '../lib/translations';

/**
 * ModalForm rendering.
 *
 * @method ModalForm
 * @return ReactComponent
 * @since 0.10.16
 */
const ModalForm = props => {
    const translate = translations.init(props);
    const closeModal = () => {
        modalFormState.on.hide();
    };

    return (
        <div className="modal-container">
            <div className="modal-form  pure-u">
                <div className="modal-content" dangerouslySetInnerHTML={{__html: modalFormState.$content.getState()}} />
                <div className="button-container">
                    <Button className="button"
                        label={translate.t('CLOSE')}
                        onClick={closeModal}
                        unelevated />
                </div>
            </div>
        </div>
    );
};

export default ModalForm;
